import { API } from '../../../api';
export default function PartnerListItem({ key, item, onHover, onEdit, onDelete }) {
  const getImageUrl = (baseUrl=API.API_LINK + "/") => {
    if (item.typesource === "web") return item.imgname;
    if (!item.imgname || !item.extension) return null;
    return `${baseUrl}file/pictures/partner/source/${item.imgname}.${item.extension}`;
  };

  return (
    <li className="admin-t1-list-item" onMouseEnter={() => onHover?.(item)}>
    	<div className="item-info">
        	<div className="item-thumb">
          		{getImageUrl() ? (
            		<img src={getImageUrl()} alt={item.enregistrementname || "Image"} onError={e => e.target.style.display = "none"} />
          		) : (
            		<div className="empty-thumb"><span>📷</span></div>
  )}
        	</div>

        	<div className="item-details">
          		<h4>{item.enregistrementname || "Sans titre"}</h4>
          		{/* <p className="item-event">{item.evenement}</p> */}
          		<p className="item-visibility">{item.isvisible ? "✓ Visible" : "✗ Masqué"}</p>
        	</div>
      	</div>

      	<div className="item-actions">
        	<button className="btn-icon btn-edit" onClick={() => onEdit(item)} title="Modifier">✏️</button>
        	<button className="btn-icon btn-delete" onClick={() => onDelete(item)} title="Supprimer">🗑️</button>
      	</div>
    </li>
  );
}